import EmailFileAttachment from './Message/EmailFileAttachment';
import EmailDocumentAttachment from './Message/EmailDocumentAttachment';

const Attachments = ({ eventId, attachments, documentBlueprints, deleteFileAttachment, deleteDocumentAttachment }) => {
  const generatedFilesTable = [];

  if (attachments) {
    attachments.map((attachment, index) => {
      generatedFilesTable.push(
        <EmailFileAttachment
          key={`file-${attachment}`}
          deleteAtIndex={deleteFileAttachment}
          index={index}
          attachment={attachment}
          eventId={eventId || undefined}
        />,
      );
    });
  }

  if (documentBlueprints) {
    documentBlueprints.map((attachment, index) => {
      generatedFilesTable.push(
        <EmailDocumentAttachment
          key={`doc-${attachment}`}
          deleteAtIndex={deleteDocumentAttachment}
          eventId={eventId || undefined}
          index={index}
          attachment={attachment}
        />,
      );
    });
  }

  const styles = {
    filesContainer: {
      display: 'flex',
      flexWrap: 'wrap',
    },
  };

  return <div style={styles.filesContainer}>{generatedFilesTable}</div>;
};

export default Attachments;
